import { useNavigate } from 'react-router-dom';
import { WifiOff } from 'lucide-react';
import ErrorPageLayout from '@/components/ux/ErrorPageLayout';

export default function NetworkErrorPage({ onRetry }) {
  const navigate = useNavigate();

  return (
    <ErrorPageLayout
      title="Unable to connect"
      description="Check your internet connection, then try again. If the problem continues, our services may be temporarily unavailable."
      icon={WifiOff}
      variant="destructive"
      primaryLabel={onRetry ? 'Try again' : 'Go to home'}
      onPrimary={onRetry || (() => navigate('/'))}
      secondaryLabel={onRetry ? 'Go to home' : undefined}
      onSecondary={onRetry ? () => navigate('/') : undefined}
    />
  );
}
